/* =============================================================
   Cosmetic Lithuanian text patch for the Kaching Bundles widget
   (product pages and the homepage stage).
   The widget's product-picker button ("Choose"), the picker's heading
   ("Choose product") and the "Most popular" badge have no Lithuanian
   translation surface for this shop's primary (lt) locale. This only
   replaces those few visible labels (and the picker's close-icon alt
   text) by editing the text of the existing text node in place, so the
   app keeps its own nodes and updates them as before. Only text inside
   Kaching's own elements is touched. No functionality, pricing or cart
   logic is changed. (Preferred long-term fix: translate the strings in
   the Kaching app settings; this patch then simply finds nothing to do.)
   ============================================================= */
(function () {
  'use strict';
  /* the script tag can be evaluated again (Theme Editor re-renders the section): observe the page only once */
  if (window.__isdKachingPatch) return;
  window.__isdKachingPatch = true;
  var MAP = {
    'choose': 'Pasirinkti',
    'choose product': 'Pasirinkite produktą',
    'most popular': 'Populiariausia'
  };
  var SCOPE = 'kaching-bundle, [class*="kaching-bundles__"]';

  function inScope(el) { return !!(el && el.closest && el.closest(SCOPE)); }

  function fixText(node) {
    var raw = node.nodeValue || '', t = raw.trim(), key = t.toLowerCase();
    var to = t && Object.prototype.hasOwnProperty.call(MAP, key) ? MAP[key] : null;
    var offer = t.match(/^add\s+(\d+)\s+more\s+to\s+get\s+(\d+(?:[.,]\d+)?)\s*%\s*off!?$/i);
    if (offer) to = 'Įdėkite dar ' + offer[1] + ' vnt. ir gaukite ' + offer[2] + ' % nuolaidą';
    if (!to || !inScope(node.parentElement)) return;
    // the widget writes some labels in capitals: keep that look
    if (t === t.toUpperCase() && t !== t.toLowerCase()) to = to.toUpperCase();
    if (t !== to) node.nodeValue = raw.replace(t, to);
  }

  function scan(root) {
    if (!root) return;
    if (root.nodeType === 3) { fixText(root); return; }
    if (root.nodeType !== 1) return;
    // skip subtrees that have nothing to do with the widget
    if (!inScope(root) && !(root.querySelector && root.querySelector(SCOPE))) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n;
    while ((n = walker.nextNode())) fixText(n);
    [].forEach.call(root.querySelectorAll('img[alt="Close"]'), function (img) { if (inScope(img)) img.alt = 'Uždaryti'; });
  }

  scan(document.body);
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === 'characterData') { fixText(m.target); continue; }
      for (var k = 0; k < m.addedNodes.length; k++) scan(m.addedNodes[k]);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
})();
